module.exports = __webpack_public_path__ + "static/media/mode-1.f6922b71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-1.svg
// module id = 956
// module chunks = 2